import React, { Component } from 'react';

class FormError extends Component {
  render() {
    return (
      <em id={this.props.id} className="text-danger error help-block">{this.props.message}</em>
    );
  }
}

export default FormError;
